import { render, staticRenderFns } from "./AddGradeData.vue?vue&type=template&id=2768e8c2&scoped=true&"
import script from "./AddGradeData.vue?vue&type=script&lang=js&"
export * from "./AddGradeData.vue?vue&type=script&lang=js&"
import style0 from "./AddGradeData.vue?vue&type=style&index=0&id=2768e8c2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768e8c2",
  null
  
)

export default component.exports